var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#204652;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m21.43,23.16c-.87,0-1.57.7-1.58,1.57,0,.88.69,1.57,1.57,1.58.87,0,1.58-.7,1.58-1.57,0-.87-.7-1.57-1.57-1.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m13.06,23.16c-.88,0-1.57.7-1.57,1.59,0,.86.71,1.56,1.57,1.55.88,0,1.57-.7,1.57-1.57,0-.87-.7-1.57-1.57-1.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m24.6,17.4l2-7c.07-.23.02-.48-.13-.67-.15-.19-.36-.29-.61-.29l-16.23.49-.51-2.4c-.07-.35-.38-.59-.73-.59h-2.25c-.41,0-.75.34-.75.75s.34.75.75.75h1.64l2.87,13.41c.07.35.38.59.73.59h12.56c.41,0,.75-.34.75-.75s-.34-.75-.75-.75h-11.96l-.33-1.53,12.31-1.48c.3-.04.55-.25.63-.54Zm-13.26.54l-1.4-6.52,14.93-.45-1.58,5.53-11.95,1.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.b36e7cfb1d9e3fe363b6688a0f0ef1d5.svg";
export { ForwardRef as ReactComponent };